import RedemptionFirstStep from "./redemption_first_step/RedemptionFirstStep.vue"
import RedemptionSecondStep from "./redemption_second_step/RedemptionSecondStep.vue"

export default {
  props: { value: Object },

  components: { RedemptionFirstStep, RedemptionSecondStep },

  data: () => ({
    currentStep: 1,
  }),

  methods: {
    incrementRedemptionStep() {
      this.currentStep++;
    },

    decrementRedemptionStep() {
      this.currentStep--;
    },
  }
};